/*
 * @author Andrey Patyuchenko
 * @email  apatyuchenko@atlassian.com
 * @email  andrey.patyuchenko@gmail.com
 * @date   10/7/21
 */

import {darkScrollbar} from "@mui/material";
import {createTheme} from "@mui/material/styles";

export default function getTheme(mode: "light" | "dark" = "light") {
	return createTheme({
		palette: {
			mode,
			primary: {
				main: mode === "light" ? "#0747A6" : "#B3D4FF"
			},
			secondary: {
				main: mode === "light" ? "#2684FF" : "#B3D4FF"
			}
		},
		components: {
			MuiCssBaseline: {
				styleOverrides: {
					body: mode === 'dark' ? darkScrollbar() : null,
				},
			},
		},
	});
}